export const EmissionRegulationTab = () => {
  return "";
};
